<template>
  <div class="login-container">
    <div class="login-wrapper">
      <div class="system-title">
        <h1 class="inline-block">AP Gaming</h1>
      </div>
      <div class="login-box">
        <div class="login-left">
          <img src="@/assets/login/theme.jpg" alt="登录背景" class="login-image" />
        </div>
        <div class="login-right">
          <div class="login-card" shadow="hover">
            <div class="logo-container text-center">
              <img style="width: 80px" src="@/assets/ap-logo.png" />
            </div>
            <el-form
              ref="loginForm"
              :model="loginForm"
              :rules="loginRules"
              class="simple-login-form mt-6"
              auto-complete="on"
              label-position="left"
            >
              <!-- <el-form-item prop="selectedWebsitePath">
                <label class="block text-sm font-medium text-gray-500 mb-2">站点</label>
                <el-cascader
                  v-model="loginForm.selectedWebsitePath"
                  class="w-full"
                  placeholder="请选择币种 / 站点"
                  :options="websiteCascaderOptions"
                  :props="websiteCascaderProps"
                  :show-all-levels="true"
                  filterable
                  clearable
                  :loading="websiteLoading"
                  @change="handleWebsiteCascaderChange"
                />
              </el-form-item> -->

              <el-form-item prop="username">
                <label for="username" class="block text-sm font-medium text-gray-500 mb-2">用户名</label>
                <el-input v-model="loginForm.username" placeholder="用户名" prefix-icon="el-icon-user" />
              </el-form-item>

              <el-form-item prop="password">
                <label for="password" class="block text-sm font-medium text-gray-500 mb-2">密码</label>
                <el-input
                  v-model="loginForm.password"
                  :type="passwordType"
                  placeholder="密码"
                  prefix-icon="el-icon-lock"
                  show-password
                />
              </el-form-item>

              <el-form-item prop="otp_code">
                <label for="password" class="block text-sm font-medium text-gray-500 mb-2">谷歌验证码</label>
                <el-input
                  v-model="loginForm.otp_code"
                  :type="passwordType"
                  placeholder="谷歌验证码"
                  prefix-icon="el-icon-key"
                />
              </el-form-item>

              <el-button :loading="loading" type="primary" class="login-btn" @click.native.prevent="handleLogin">
                登录
              </el-button>
            </el-form>
          </div>
        </div>

        <!-- OTP二维码弹窗 -->
        <el-dialog
          title="OTP code"
          :visible.sync="otpDialogVisible"
          width="400px"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :show-close="false"
          center
        >
          <div class="otp-dialog-content text-center">
            <div class="qrcode-container">
              <!-- <qrcode-vue :value="otpQrCode" :size="200" level="M" /> -->
              <img style="margin: 0 auto; width: 400px" :src="otpQrCode" />
            </div>
            <div class="otp-info mt-4">
              <!-- <el-input
                v-model="otpQrCode"
                readonly
                placeholder="OTP二维码值"
                class="mb-2"
              >
                <template slot="suffix">
                  <el-button
                    type="text"
                    icon="el-icon-document-copy"
                    title="复制OTP码"
                    style="padding: 0; margin-right: 10px;margin-top: 10px;"
                    @click.stop="handleCopyOtp"
                  />
                </template>
              </el-input> -->
              <div class="warning-text text-danger">
                <i class="el-icon-warning" />
                <span>请务必扫码记录此OTP码，用于后续登录验证！</span>
              </div>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handleOtpRecorded">继续登录</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'
import axios from 'axios'
import Storage from '@/utils/storage'
import { setBaseURL } from '@/utils/request'

export default {
  name: 'Login',
  components: {
    QrcodeVue,
  },
  data() {
    return {
      websites: [],
      websiteLoading: false,

      websiteCascaderOptions: [],
      websiteCascaderProps: {
        emitPath: true,
        expandTrigger: 'hover',
      },
      loginForm: {
        // username: 'admin',
        // password: '1',
        selectedWebsitePath: [],
        username: '',
        password: '',
        otp_code: '',
      },
      loginRules: {
        // selectedWebsitePath: [{ required: true, trigger: 'blur', message: '请选择站点' }],
        username: [{ required: true, trigger: 'blur', max: 32, message: '请输入用户名' }],
        password: [{ required: true, trigger: 'blur', max: 32, message: '请输入密码' }],
        otp_code: [{ required: false, trigger: 'blur', max: 6, min: 6, message: '请输入正确的验证码' }],
      },
      loading: false,
      passwordType: 'password',
      redirect: undefined,
      // OTP二维码弹窗相关数据
      otpDialogVisible: false,
      otpQrCode: '',
    }
  },
  created() {
    // this.fetchWebsiteList()
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true,
    },
  },
  methods: {
    async fetchWebsiteList() {
      this.websiteLoading = true
      try {
        // 开发环境通过 devServer 反向代理避免跨域：/api/v1/gate -> https://dev.pay.berich.cloud/api/v1/gate
        // const res = await axios.get('/api/v1/gate/website/list?currency=NGN')
        const res = await axios.get('https://dev.pay.berich.cloud/api/v1/gate/website/list')

        const items = res?.data?.data?.items || []
        this.websites = Array.isArray(items) ? items : []

        const cached = Storage.get('SelectedWebsite')
        const cachedApi = cached?.api

        // 生成级联数据：currency -> websites
        const groups = this.websites.reduce((acc, w) => {
          const currency = w?.currency || 'UNKNOWN'
          if (!acc[currency]) acc[currency] = []
          acc[currency].push(w)
          return acc
        }, {})

        this.websiteCascaderOptions = Object.keys(groups).map(currency => {
          const children = (groups[currency] || []).map(w => ({
            value: w.api,
            label: w.name,
            description: w.description,
            currency: w.currency,
          }))
          return {
            value: currency,
            label: currency,
            children,
          }
        })

        const exists = cachedApi && this.websites.some(w => w.api === cachedApi)
        const defaultWebsite = exists ? this.websites.find(w => w.api === cachedApi) : this.websites[0]
        this.selectedWebsitePath = defaultWebsite?.api ? [defaultWebsite.currency || 'UNKNOWN', defaultWebsite.api] : []
        if (this.selectedWebsitePath.length === 2) {
          this.handleWebsiteCascaderChange(this.selectedWebsitePath)
        }
      } catch (e) {
        console.error('fetch website list failed', e)
      } finally {
        this.websiteLoading = false
      }
    },
    handleWebsiteCascaderChange(path) {
      const api = Array.isArray(path) ? path[1] : undefined
      if (!api) return
      const website = this.websites.find(w => w.api === api)
      if (!website?.api) return

      Storage.set('SelectedWebsite', website)
      setBaseURL(website.api)
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          const data = {
            ...this.loginForm,
            role: 'admin',
          }
          this.$store
            .dispatch('user/login', data)
            .then(res => {
              this.loading = false
              if (res.otp_qr_code) {
                // 展示OTP二维码弹窗
                this.otpQrCode = res.otp_qr_code
                this.otpDialogVisible = true
              } else {
                // 正常登录成功，跳转到首页
                this.handleRedirect()
              }
            })
            .catch(err => {
              console.error(err)
              this.loading = false
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleOtpRecorded() {
      this.otpDialogVisible = false
      // 关闭弹窗后跳转到首页
      this.handleRedirect()
    },
    handleRedirect() {
      const home = '/welcome'
      this.$router.push({ path: this.redirect || home })
      this.$message.success('登录成功')
    },
    async handleCopyOtp() {
      try {
        // 确保获取到正确的值
        const otpValue = String(this.otpQrCode || '')
        if (!otpValue) {
          this.$message.error('OTP码为空，无法复制')
          return
        }

        // 使用现代Clipboard API
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(otpValue)
          this.$message.success('OTP码已复制到剪贴板')
        } else {
          // 降级方案：使用传统方法
          throw new Error('Clipboard API not available')
        }
      } catch (err) {
        console.error('复制失败:', err)
        this.$message.error('复制失败，请手动复制')
      }
    },
  },
}
</script>

<style scoped>
.login-container {
  height: 100vh;
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
  background-image: url('../../assets/login/bg.jpg');
}

.login-wrapper {
  width: 100%;
  max-width: 1200px;
}

.system-title {
  text-align: center;
  margin-bottom: 40px;
}

.system-title h1 {
  color: white;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  font-size: 2.5rem;
  margin: 0;
}

.login-box {
  display: flex;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.login-left {
  flex: 1;
  position: relative;
}

.login-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.login-right {
  flex: 0 0 auto;
  width: 460px;
  background-color: white;
  padding: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-card {
  width: 100%;
  max-width: 300px;
  border: none;
}

.login-form {
  padding: 20px 0;
}

.forgot-link {
  float: right;
}

.login-btn {
  width: 100%;
  height: 40px;
  font-size: 16px;
}

@media (max-width: 768px) {
  .login-left {
    display: none;
  }
  .login-right {
    width: 100%;
  }
}

/* OTP弹窗样式 */
.otp-dialog-content {
  padding: 0;
}

.qrcode-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.otp-info {
  margin-top: 20px;
}

.warning-text {
  margin-top: 10px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.warning-text i {
  margin-right: 5px;
}
</style>
